module.exports = __webpack_public_path__ + "img/hello.d5cb70ff.png";